<template>
  <StageScaler>
    <VideosStageWithPopup
      data-testid="videos-stage-with-popup"
      :logo="$store.getters['branding/theme_obj'].logo_url"
      :demoButtonText="$store.getters['branding/theme_obj'].demo_request_button_text"
      :showDemoLink="$store.getters['branding/theme_obj'].demo_link_enabled"
      :customDemoCtaLinkTo="$store.getters['branding/theme_obj'].custom_demo_cta_link_to"
      :title="$store.getters['branding/theme_obj'].demo_request_title"
      :message="$store.getters['branding/theme_obj'].demo_request_message"
      :targets="$store.getters['branding/currentTargets']"
      :navigatorLinks="$store.getters['branding/navigatorLinks']"
      :stageChatTabs="$store.getters['branding/stageChatTabs']"
      :sidebarPrimaryTabs="$store.getters['branding/sidebarPrimaryTabs']"
    />
  </StageScaler>
</template>

<script>
import { VideosStageWithPopup } from '@goldcast/uicomponents-branding';

import StageScaler from './StageScaler.vue';

export default {
  name: 'VideosStageWithPopupPreview',
  components: { VideosStageWithPopup, StageScaler }
};
</script>
